export enum ShipmentFinancialsAction {
  COST_ALLOCATION = 'COST_ALLOCATION',
  CREATE_INVOICE = 'CREATE_INVOICE',
  REFRESH = 'REFRESH',
}
